<template>
    <!-- Logout Modal-->
    <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">訊息</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            </div>
            <div class="modal-body">是否確定登出</div>
            <div class="modal-footer">
            <button class="btn btn-secondary" type="button" data-dismiss="modal">取消</button>
            <a class="btn btn-primary"  v-on:click="Logout" >確定</a>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Logout',
  data () {
    return {
    }
  },
  methods: {
    Logout() {
        //  localStorage.clear();
        $("#logoutModal").modal('hide');
        //  this.$router.push({name: 'Login'});
    }
  }
}
</script>
<style scoped>
.btn{
  color:white;
}
</style>




// WEBPACK FOOTER //
// src/components/shared/Logout.vue